var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.loading)?_c('CrudIndex',{attrs:{"title":"Reason Code","viewColumns":_vm.columns,"fetchUrl":"/reason-codes","createUrl":"/reason-codes","updateRootUrl":"/reason-codes","deleteRootUrl":"/reason-codes","permission":_vm.PERMISSION_CODES.CMS_VIEW_REASON_CODE,"createFields":_vm.createFields,"reloadOnSuccess":true}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }